import React, { Component } from 'react';

// FrontContoller
import View from './core/routes';

class App extends Component {
  render() {
    return (
      <div className="App">
        <View></View>
      </div>
    );
  }
}

export default App;
